
<div class="card-container">
  <!-- <app-transaction-summary-ribbon [state]="mapperTransactionState" [initialPayloadInEdit]="payloadInEdit"
     [InboxType]="_inboxType" [stateToProgressMapper]="stateToProgressMapper" (documentManagerHandler)="bulkDocumentUploadHandler($event)">
    </app-transaction-summary-ribbon>   -->
       <!-- (documentManagerHandler)="documentManagerHandler($event)" (sendCaseStatus)="caseStatus($event)"   -->
  </div>
  <h3 class="heading">Bulk Process</h3>
  <div class="m-b-20">
    <div class="">
      <div class="bulk-process-actions">
        <div class="m-r-10">
          <!-- <div> -->
            <h3>Filter</h3>
          <!-- </div> -->
          <nz-select nzShowSearch nzAllowClear [(ngModel)]="selectedFilter" style="min-width: 200px;"
            (ngModelChange)="filterCasesOnCategory(selectedFilter)">
            <nz-option
                *ngFor="let item of (lookup$['claimStageCd'] | async) as bulkStageCd"
                [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey">
              </nz-option>
          </nz-select>
        </div>
        <!-- Inbox Type Switcher: My/Subordinate/Team -->
        <!-- <div *ngIf="userRoleDO['roleId'] !== 'PARTNER' && userRoleDO['roleId'] !== 'BRANCH' && userRoleDO['roleId'] !== 'CLAIM_BRANCHINTIMATION'" class="m-r-10">
            <h3>Action</h3>
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select Stage" [(ngModel)]="nextClaimStage" style="min-width: 150px;
          margin-right: 5px;">
            <nz-option *ngFor="let item of filteredClaimStageLookup" [nzLabel]="item?.lookupValue"
              [nzValue]="item?.lookupKey"></nz-option>
          </nz-select>
        </div> -->
        <!-- <div *ngIf="userRoleDO['roleId'] !== 'PARTNER' && userRoleDO['roleId'] !== 'BRANCH' && userRoleDO['roleId'] !== 'CLAIM_BRANCHINTIMATION'">
          <button nz-button class="m-r-10" [nzType]="'success'" [disabled]="!nextClaimStage || !selectedFilter" (click)="submitTransaction()">
            Proceed
          </button>
        </div> -->
      </div>
      <div>
  
      </div>
    </div>
  </div>
  
  
  <nz-table #bulkDetailTable [nzData]="bulkStatusDataFiltered" nzTableLayout="fixed" [nzShowPagination]="true" nzZIndex="100" [nzScroll]="{ x: '1150px' }">
    <thead (nzSortChange)="sort($event)" nzSingleSort>
      <tr>
        <th translate style="min-width: 110px; display: table-cell;">
          <label nz-checkbox name="checkall" [(ngModel)]="allChecked" (ngModelChange)="updateAllChecked()">
            
          </label>
          Check all
        </th>
        <th style="min-width: 130px;" nzShowSort nzSortKey="proposalNum" translate>Proposal Number</th>
        <th style="min-width: 130px;" nzShowSort nzSortKey="insuredFirstName" translate>Insured</th>
        <th style="min-width: 130px;" nzShowSort nzSortKey="claimantFirstName" translate>Claimant Name</th>
        <th style="min-width: 130px;" nzShowSort nzSortKey="eventTypeCd" translate>Event Type</th>
        <th style="min-width: 130px;" nzShowSort nzSortKey="eventDt" nzShowSort nzSortKey="eventDt" translate>Event Date</th>
        <th style="min-width: 130px;" nzShowSort nzSortKey="intimationDt" translate>Intimation Date</th>
        <!-- <th style="min-width: 130px;" nzShowSort nzSortKey="clmIntimationNum" translate>Intimation No</th> -->
        <!-- <th style="min-width: 130px;" nzShowSort nzSortKey="intimationStatus" translate>Intimation Status</th> -->
        <th style="min-width: 130px;" nzShowSort nzSortKey="claimNum" translate>Reg. Number</th>
        <th style="min-width: 130px;" nzShowSort nzSortKey="insuredFirstName" translate>Claim Status</th>
        <th style="min-width: 130px;" nzShowSort nzSortKey="claimStatus" translate>Pending Requirement</th>
        <th style="min-width: 130px;" translate>Requirement</th>
        <!-- <th *ngFor="let column of listOfColumn" nzShowSort nzSortKey="coloumn.priority">
          {{ column.title }}
        </th> -->
    </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of bulkDetailTable.data">
        <td><label nz-checkbox [(ngModel)]="data['isSelectedCase']"></label></td>
        <td>{{data?.proposalNum ? data?.proposalNum : '-'}}</td>
        <td>{{data?.insuredFirstName ? data?.insuredFirstName : '' }} {{data?.insuredLastName ? data?.insuredLastName : '' }}</td>
        <td>{{data?.claimantFirstName ? data?.claimantFirstName : '' }} {{data?.claimantLastName ? data?.claimantLastName : '' }}</td>
        <td>{{data?.eventTypeCd ? (data.eventTypeCd | technicalTranslate) : '-' }}</td> 
        <td>{{data?.eventDt ? getLocalDateString(data?.eventDt)  : '-'}} </td>
        <td>{{data?.intimationDt ? getLocalDateString(data.intimationDt) : '-' }}</td> 
        <!-- <td><a (click)="openTransactionDetails('claimBranchIntimation',data.intimationGuid,'search')">
          {{data?.clmIntimationNum ? data?.clmIntimationNum  : '-'}}</a></td> -->
        <!-- <td>{{data?.intimationStatus ? (data?.intimationStatus | technicalTranslate)  : '-'}} </td> -->
        <td> <a (click)="openRegistrationTransactionDetails(data.intimationStage,data.claimGuid,'search',false)">
          {{data?.claimNum ? data?.claimNum  : '-'}}</a> </td>
        <td>{{data?.claimStatus ? (data?.claimStatus | technicalTranslate)  : '-'}} </td>
        <td>{{data?.pendingAllReqFl ? 'Yes' : 'No'}} </td>
        <td><span><a (click)="documentManagerHandler(data.claimGuid ? data.claimGuid : data.intimationGuid)"> Attach Documents</a></span></td>
      </tr>
    </tbody>
  </nz-table>
  
  <!-- DOCUMENT PANEL // DOCUMENT MANAGER -->
  <nz-drawer [nzClosable]="true" [nzWidth]="460" [nzPlacement]="'right'" nzTitle="Document Manager"
    [nzVisible]="docuPanelOpen" (nzOnClose)="docuPanel(0)">
    <div>
      <app-document-manager *ngIf="docuPanelOpen"
      [requirements]="requiremets" [inputDataForEdit]="documents" [RequirementEntityGuid]="transactionGuid">
      </app-document-manager>
    </div>
  </nz-drawer>
  
  
  <!-- Footer -->
  <div class="card-summary-data-footer _data-footer-primary" style="display: flex; justify-content: end;">
  </div>
  
  
  <nz-modal nzWidth="80%" [(nzVisible)]="openBulkUploadModal" nzTitle="Bulk Document Upload" (nzOnOk)="openBulkUploadModal=false"
      nzOkText="Done" (nzOnCancel)="openBulkUploadModal=false">
      <app-new-bulk [source]="'transaction'" [batchId]="batchId"></app-new-bulk>
    </nz-modal>
  <!--Bulk Document upload modal nzOkText="Submit"   -->
  